<template>
  <div v-if="error" class="error">
    <slot name="error">
      {{ error }}
    </slot>
  </div>
</template>

<script setup>
defineProps({
  error: {
    type: String,
    required: false,
  },
});
</script>

<style lang="scss" scoped>
.error {
  color: var(--rust-50);
}
</style>
